/**
 * Location inference from hostname for multi-tenant subdomain routing
 * 
 * Examples:
 * - toronto.104.app → 'toronto'
 * - nyc.104.app → 'nyc'
 * - california.104.app → 'california'
 * - localhost → 'toronto' (default for dev)
 * - 104sandbox.onezerofour.live → 'toronto' (fallback - not a valid location)
 */

const RESERVED = new Set(['www', 'app', 'admin', 'localhost']);
const DEFAULT_LOCATION = 'toronto';

// Locations válidas conhecidas no banco de dados
const VALID_LOCATIONS = new Set(['toronto', 'nyc', 'california']);

// Palavras-chave que indicam que o subdomínio NÃO é uma location (sandbox, test, staging, etc)
const NON_LOCATION_KEYWORDS = new Set([
  'sandbox', 'test', 'staging', 'dev', 'development', 
  'preview', 'demo', 'beta', 'alpha'
]);

export function inferLocationFromHost(hostname: string): string {
  const sub = (hostname.split('.')[0] || DEFAULT_LOCATION).toLowerCase();
  
  // Se está na lista de reservados, usa default
  if (RESERVED.has(sub)) {
    return DEFAULT_LOCATION;
  }
  
  // Verifica se contém palavras-chave que indicam não-location
  // Ex: "104sandbox" contém "sandbox"
  const containsNonLocationKeyword = Array.from(NON_LOCATION_KEYWORDS).some(keyword => 
    sub.includes(keyword)
  );
  
  if (containsNonLocationKeyword) {
    return DEFAULT_LOCATION;
  }
  
  // Se NÃO é uma location válida conhecida, usa default
  // Isso previne problemas quando subdomínios desconhecidos são usados
  if (!VALID_LOCATIONS.has(sub)) {
    return DEFAULT_LOCATION;
  }
  
  // Retorna a location válida
  return sub;
}
